// TODO: decision - switch to NgCore consts in future roadmap [future release]

// AU
// dateAfterValidator is strictly-after; use day before GST commencement so 1 Jul 2000 is valid
export const AU_GST_COMMENCED = new Date(2000, 5, 30); // 30th Jun 2000 (min exclusive bound for 1 Jul 2000)
